import script from "./Statistic2.vue?vue&type=script&setup=true&lang=ts"
export * from "./Statistic2.vue?vue&type=script&setup=true&lang=ts"

import "./Statistic2.vue?vue&type=style&index=0&id=d6042c24&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6042c24"]])

export default __exports__